// Zwei installierbare PWAs auf einer Domain (app.kewagpage.ch):
// je nach Bereich das passende Manifest + Apple-Metadaten aktiv setzen.
// Die Trennung des Zugriffs bleibt allein über Rollen/Server — das Manifest steuert nur
// Name, Icon und Start-URL der jeweils installierbaren App.
const APPS = {
  "control-os": {
    manifest: "/manifest-control-os.json",
    title: "KEWAGPage Control OS",
    appleIcon: "/apple-touch-icon-control.png",
  },
  "cockpit": {
    manifest: "/manifest-cockpit.json",
    title: "KEWAGPage Website-Cockpit",
    appleIcon: "/apple-touch-icon-cockpit.png",
  },
};

function ensureLink(rel) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
}

export function setPwaContext(key) {
  const app = APPS[key];
  if (!app || typeof document === "undefined") return;
  const m = ensureLink("manifest");
  if (m.getAttribute("href") !== app.manifest) m.setAttribute("href", app.manifest);
  const ai = ensureLink("apple-touch-icon");
  if (ai.getAttribute("href") !== app.appleIcon) ai.setAttribute("href", app.appleIcon);
  let meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "apple-mobile-web-app-title");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", app.title);
}

export function pwaKeyForPath(pathname) {
  const p = pathname || "";
  if (p === "/admin/login" || p.startsWith("/admin")) return "control-os";
  if (p === "/login" || p === "/cockpit/login" || p.startsWith("/cockpit")) return "cockpit";
  return null;
}

export { APPS as PWA_APPS };
